// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3cZGn","approved":"Status_approved__258Nd","rejected":"Status_rejected__1kVCn","expired":"Status_expired__107M0","label":"Status_label__2wYzu"};